import React from 'react';
import { Content, ButtonToolbar } from 'rsuite';
import { modifyAccess } from '../../../helpers/permission';
import * as PERMISSIONS from '../../../constants/permissions/reservation';
import AccessControl from '../../../components/AccessControl';
import AccessDenied from '../../../components/AccessDenied';
import PageHeader from '../../../components/PageHeader';
import PageLayout from '../../../components/reservations/PageLayout';
import EventSearch from '../../../containers/reservations/Search/UpcomingEvents';
import UpcomingEventsList from '../../../containers/reservations/UpcomingEventsList';

export default () => (
  <PageLayout>
    <AccessControl
      allowOnlyFor={modifyAccess(PERMISSIONS.MODULE)}
      fallback={<AccessDenied />}
    >
      <PageHeader title="Upcoming Events">
        <ButtonToolbar>
          <EventSearch placeholder="Type outreach and press enter" />
        </ButtonToolbar>
      </PageHeader>
      <Content>
        <UpcomingEventsList />
      </Content>
    </AccessControl>
  </PageLayout>
);
